<template>
    <div class="main_body">
        <!-- <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" /> -->
        <div class="container-fluid">
            <div style="margin-left:20px;" class="pb-4">
                <h2>Top User</h2>
            </div> 
            <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 align-content-center justify-content-center">
                <div class="btn-group" role="group" aria-label="Basic example">
                    <button @click="audiobook" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">AudioBook Top
                        User</button>
                    <button @click="episode" class=" btn btn-primary" type="button" aria-expanded="false"
                        aria-controls="collapseExample">Episode Top User</button>
                </div>
            </div>
            <div class="row mt-5">
                <div v-if="flag1 === true" class="collapse show" id="collapseExample1">
                    <AudioBookTopUser></AudioBookTopUser>
                </div>
                <div v-if="flag2 === true" class="collapse show" id="collapseExample2">
                    <EpisodeTopUser></EpisodeTopUser>
                </div>
            </div>
            <div class="row mt-5">
                <div v-if="loadFlag === true" class="collapse show" id="collapseExample1">
                    <AudioBookTopUser></AudioBookTopUser>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import EpisodeTopUser from './EpisodeTopUser'
import AudioBookTopUser from './AudioBookTopUser';
export default {
    data() {
        return {
            flag1: false,
            flag2: false,
            loadFlag:true
        }
    },

    components: {
        AudioBookTopUser,
        EpisodeTopUser
    },

    methods: {
        audiobook() {
            this.flag1 = !this.flag1
            this.flag2 = false
            this.loadFlag = false
        },
        episode() {
            this.flag2 = !this.flag2
            this.flag1 = false
            this.loadFlag = false
        }
    }
}
</script>

<style>
    .btn-group button{
        background: black;
    }
</style>